import createSelector from "../../utils/reselect";

const generalStateData = (state) => {
  const { general } = state;
  return general || {};
};

export const getSettings = createSelector(generalStateData, (general) => {
  const u = general.get("settings") || null;
  if (u) {
    return JSON.parse(JSON.stringify(u));
  }
  return u;
});

export const dashboardSummary = createSelector(generalStateData, (general) =>
  general.get("dashboardSummary")
);

export const reminderDetail = createSelector(generalStateData, (general) =>{
  const reminder = general.get("reminder");
  return reminder && reminder.hasOwnProperty("title") ? reminder : null;
}
);

export const reminders = createSelector(generalStateData, (general) =>
  general.get("reminders")
);
export const createdReminders = createSelector(generalStateData, (general) =>
  general.get("createdReminders")
);

export const notificationsList = createSelector(generalStateData, (general) =>
  general.get("notificationsList")
);

export const loading = createSelector(generalStateData, (general) =>
  general.get("loading")
);

export const error = createSelector(generalStateData, (general) =>
  general.get("error")
);

export const updateLogoLoading = createSelector(generalStateData, (general) =>
  general.get("updateLogoLoading")
);

export const getNotificationToast = createSelector(
  generalStateData,
  (general) => general.getIn(["notificationToast"])
);

export const getToastList = createSelector(generalStateData, (general) =>
  general.getIn(["toastList"])
);

export const getNavExpand = createSelector(
  generalStateData,
  (general) => !general.get("navExpand")
);

export const getExpRes = createSelector(generalStateData, (general) =>
  general.get("expRes")
);
export const getExpClients = createSelector(generalStateData, (general) =>
  general.get("expClients")
);
export const getExpMeetings = createSelector(generalStateData, (general) =>
  general.get("expMeetings")
);
export const getExpProjects = createSelector(generalStateData, (general) =>
  general.get("expProjects")
);

export const isModal = createSelector(generalStateData, (general) =>
  general.get("modal")
);

export const pjmDashboardSummary = createSelector(generalStateData, (general) =>
  general.get("pjmDashboardSummary")
);

export const pjmDashboardDetail = createSelector(generalStateData, (general) =>
  general.get("pjmDashboardDetail")
);

export const prmDashboardSummary = createSelector(generalStateData, (general) =>
  general.get("prmDashboardSummary")
);

export const prmDashboardDetail = createSelector(generalStateData, (general) =>
  general.get("prmDashboardDetail")
);

export const pomDashboardSummary = createSelector(generalStateData, (general) =>
  general.get("pomDashboardSummary")
);

export const pomDashboardDetail = createSelector(generalStateData, (general) =>
  general.get("pomDashboardDetail")
);

export const pomDashboardLoading = createSelector(generalStateData, (general) =>
  general.get("loading") === true
);

export const pomDashboardDetailLoading = createSelector(generalStateData, (general) =>
  general.get("detailLoading") === true
);